// extracted by mini-css-extract-plugin
export default {"description":"AddExtraData_description__ntiEe"};